import { api } from "./client";

export interface LeakResult {
  id: string;
  title: string;
  source: string;
  date: string;
  snippet: string;
}

export const checkCustomerData = async (query: string): Promise<LeakResult[]> => {
  const response = await api.post<LeakResult[]>(
    "/customer-check/check",
    { query }
  );
  return response.data;
};
